$(function(){
  class ScrollPhotoWall extends HTMLElement {
    constructor() {
      super();
      console.log($(this)[0])
      this._pcNum = $(this).attr('data-pcnum');
      this._sectionId = $(this).attr('data-sectionid');
      this._rowGap = $(this).attr('data-rowgap');
      console.log(this._pcNum,this._sectionId,this._rowGap)

      this.initSPWSwiper();
    }

    initSPWSwiper(){
      new Swiper(`.spw-swiper_${this._sectionId}`, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay:{
          disableOnInteraction: false,
        },
        breakpoints: {
          749: {
            slidesPerView: 2,
            spaceBetween: Number(this._rowGap),
          },
          990: {
            slidesPerView: Number(this._pcNum),
            spaceBetween: Number(this._rowGap),
          }
        },
      });
  
    }
  
  
   
  }
  
  if (!customElements.get('scroll-photo-wall')) {
    customElements.define('scroll-photo-wall', ScrollPhotoWall);
  }

})